export const FontFamily = {
  default:
    'Geist,Inter,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,Helvetica Neue,Icons16,sans-serif',
  monospace:
    'Geist Mono,Roboto Mono,SF Mono,SFMono-Regular,ui-monospace,Source Code Pro,Menlo,Monaco,Cascadia Mono,Segoe UI Mono,Oxygen Mono,Ubuntu Monospace,Fira Mono,Droid Sans Mono,Courier New,monospace',
};
